var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "table-container" },
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { xs: 24, sm: 24, md: 12, lg: 24, xl: 24 } },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  ref: "tableSort",
                  attrs: { data: _vm.list, border: "" },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "序号",
                      align: "center",
                      width: "80",
                      prop: "seq",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "职位" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(" " + _vm._s(scope.row.title || "-") + " "),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "薪资", width: "150" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(" " + _vm._s(scope.row.salary || "-") + " "),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "经验(年)", width: "80" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(" " + _vm._s(scope.row.years || "-") + " "),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "地点" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " + _vm._s(scope.row.location || "-") + " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "学历", width: "120" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " + _vm._s(scope.row.education || "-") + " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "发布日期", width: "120", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(" " + _vm._s(scope.row.date || "-") + " "),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "操作",
                      width: "100px",
                      fixed: "right",
                      align: "center",
                      fit: "true",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  effect: "dark",
                                  content: "查看详情",
                                  placement: "top-start",
                                },
                              },
                              [
                                _c("el-button", {
                                  attrs: {
                                    size: "mini",
                                    type: "primary",
                                    icon: "el-icon-document",
                                    circle: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.showDetail(scope.row)
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.total > 0
        ? _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { xs: 24, sm: 24, md: 12, lg: 24, xl: 24 } },
                [
                  _c(
                    "el-card",
                    [
                      _c("el-pagination", {
                        attrs: {
                          "current-page": _vm.queryForm.pageNum,
                          "page-size": _vm.queryForm.pageSize,
                          total: _vm.total,
                          background: _vm.background,
                        },
                        on: {
                          "current-change": _vm.handleCurrentChange,
                          "size-change": _vm.handleSizeChange,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "开庭公告详情",
            visible: _vm.flag,
            "close-on-click-modal": false,
            width: "55%",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.flag = $event
            },
            close: _vm.close,
          },
        },
        [
          _c(
            "table",
            {
              staticClass: "info-table",
              staticStyle: { width: "100%", height: "100%" },
              attrs: { cellspacing: "0" },
            },
            [
              _c("tbody", [
                _c("tr", [
                  _c("td", [_vm._v("职位名称")]),
                  _c("td", [_vm._v(_vm._s(_vm.report.title || "-"))]),
                  _c("td", [_vm._v("发布日期")]),
                  _c("td", [_vm._v(_vm._s(_vm.report.date || "-"))]),
                ]),
                _c("tr", [
                  _c("td", [_vm._v("工作地点")]),
                  _c("td", [_vm._v(_vm._s(_vm.report.location || "-"))]),
                  _c("td", [_vm._v("薪资待遇")]),
                  _c("td", [_vm._v(_vm._s(_vm.report.salary || "-"))]),
                ]),
                _c("tr", [
                  _c("td", [_vm._v("学历要求")]),
                  _c("td", [_vm._v(_vm._s(_vm.report.education || "-"))]),
                  _c("td", [_vm._v("工作经验")]),
                  _c("td", [_vm._v(_vm._s(_vm.report.years || "-"))]),
                ]),
                _c("tr", [
                  _c("td", [_vm._v("工作类型")]),
                  _c("td", [_vm._v(_vm._s(_vm.report.job_type || "-"))]),
                  _c("td", [_vm._v("招聘人数")]),
                  _c("td", [_vm._v(_vm._s(_vm.report.number || "-"))]),
                ]),
                _c("tr", [
                  _c("td", [_vm._v("职位描述")]),
                  _c("td", { attrs: { colspan: "3" } }, [
                    _vm._v(_vm._s(_vm.report.description || "-")),
                  ]),
                ]),
              ]),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }